// P0 (Batch 1.5) — shared network circuit breaker for the fire-and-forget
// cloud loggers (child_attempts, milestone_events).
//
// On flaky/captive school wifi the loggers were each free to keep issuing
// inserts that hang until the (now 8s) fetch timeout, every call holding a
// socket. Dozens of those at once → ERR_INSUFFICIENT_RESOURCES. This breaker
// trips after N CONSECUTIVE failed persist calls and then SHORT-CIRCUITS
// subsequent calls for a cooldown window — they return immediately without
// touching the network (the local-first mirror already has the data). Any
// success closes the breaker. Pure + injectable clock so it's unit-testable.

const FAILURE_THRESHOLD = 4; // consecutive failed persist calls before opening
const COOLDOWN_MS = 30_000; // how long the breaker stays open

let consecutiveFailures = 0;
let openUntil = 0;

/** True while the breaker is open — callers should skip the network write. */
export function isCircuitOpen(now: number = Date.now()): boolean {
  return now < openUntil;
}

/** A persist call that reached the network and succeeded → close the breaker. */
export function recordSuccess(): void {
  consecutiveFailures = 0;
  openUntil = 0;
}

/** A persist call that exhausted its retries → step toward / hold open. */
export function recordFailure(now: number = Date.now()): void {
  consecutiveFailures += 1;
  if (consecutiveFailures >= FAILURE_THRESHOLD) {
    openUntil = now + COOLDOWN_MS;
  }
}

export const __test = {
  reset(): void {
    consecutiveFailures = 0;
    openUntil = 0;
  },
  state(): { consecutiveFailures: number; openUntil: number } {
    return { consecutiveFailures, openUntil };
  },
  FAILURE_THRESHOLD,
  COOLDOWN_MS,
};
